module.exports = __webpack_public_path__ + "img/utg_vit.da86a8dc.svg";